import { QueryClient } from '@tanstack/react-query';

/**
 * Zentraler TanStack-Query-Client der Admin-App.
 *
 * `networkMode: 'always'` ist bewusst gesetzt: Automatisierungs-/Headless-Browser
 * melden `navigator` fälschlich als offline, wodurch Queries sonst dauerhaft in
 * `fetchStatus: 'paused'` hängen blieben. Defaults bewusst konservativ.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'always',
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      networkMode: 'always',
    },
  },
});
